export default function timeFactory($rootScope, houseService, Error) {
    var factory = this;

    factory.mobiInstance = {};

    /** @type {Object} [ mobiscroller default object ] */
    factory.defaultSelectedTimeObj = {};

    /** @type {Object} [ mobiscroller init object ] */
    factory.selectedTimeObj = {};

    /**
     * Listen to Events
     * Should Instantiate Mobiscroller
     *
     * @param  $event           $on event
     * @return void
     */
    $rootScope.$on("checkMobiscrollBroadcast", function () {
        // avail param : $event
        /**
         * [description]
         *
         * Check if mobilscroller has been instantiated!
         * If not! Do it
         * Else: update the value
         *
         * MobiScroller needs to be instantiated a bit late.
         * Current solution is to wait until the dropdown opens
         * Downside - Cannot change wheels dynamically (directly) until it has been instantiated
         *
         * @param  none
         * @return void
         */
        if (factory.mobiscrollInstance !== null) {
            // Destroy in order to rebind
            factory.mobiscrollInstance.destroy();
        }
        factory.mobiscroll_init(
            factory.timeSelectorModel,
            factory.selectedTimeObj,
            factory.oSearchTime
        );
    });

    // $rootScope.$on("closing-dropdown", function ($event, oSearchInput) {
    //     if (oSearchInput.name == "search-time") {
    //         // Destroy in order to rebind when user opens dropwdown next time (issue - when navigating it needs to be destroyed an reinitiated)
    //         factory.mobiscrollInstance.destroy();
    //     }

    //     //console.log( factory.mobiscrollInstance );
    // });

    factory.init = function (oSearchTime) {
        factory.oSearchTime = oSearchTime;

        // set "hele dagen" as default Item
        factory.defaultSelectedTimeObj = factory.timeSelectorModel[5];
        factory.selectedTimeObj = factory.defaultSelectedTimeObj;

        factory.mobiInstance = factory.mobiscroll_init(
            factory.timeSelectorModel,
            factory.selectedTimeObj,
            oSearchTime
        );

        return factory.mobiInstance;
    };

    /**********************************************************************
     * MOBISCROLL WHEEL (scroller)
     * https://docs.mobiscroll.com/3-0-1/javascript/scroller#!method-setVal
     ***********************************************************************/

    factory.mobiscroll_init = function (
        timeSelectorModel,
        selectedTimeObj,
        oSearchTime
    ) {
        // Gets called when dropdown is opened the first time!
        // However there is a Downside - Cannot change wheels dynamically until it has been instantiated

        factory.mobiscrollInstance = mobiscroll.scroller("#timeCapture", {
            theme: "android-holo-light",
            display: "inline",
            lang: "da",
            showLabel: false,
            circular: [false, false],
            width: 300,
            layout: "fixed",
            height: 44,
            rows: 6,
            wheels: [
                [
                    {
                        label: "",
                        data: timeSelectorModel,
                        cssClass: "from-time-wheel",
                        key: "from-time",
                    },
                ],
            ],
            onInit: function (event, inst) {
                // $scope.oSearchTime.mobiscroll = {
                //     'init'  : true,
                //     'update' : 1
                // }

                // set wheel value init values
                inst.setVal(selectedTimeObj.value + " 1");
            },
            // onItemTap: function (event, inst) {
            // },
            onMarkupReady: function (event) {
                //avail params : event, inst
                $(event.target).find(".mbsc-sc-whl").attr("tabindex", 5);
            },
            onShow: function (event) {
                //avail params : event, inst
                $(event.target).find(".mbsc-sc-whl").focus();

                factory.setTabIndexTimeOnOpen();
            },
            // onSet: function(event, inst) {},
            onChange: function (event, inst) {
                //avail params : event, inst

                //$scope.$apply(function () { // trigger digest cycle ( not needed atm . Posssibly needed if dynamic updint wheel)

                // find needle in haystack! ( times array! )
                var wheelObj = timeSelectorModel.filter(function (obj) {
                    return obj.value == inst._wheelArray;
                })[0];

                factory.selectedTimeObj = wheelObj;

                factory.setHouseTimes(oSearchTime, wheelObj);

                //});
            },
            // onDestroy: function(event, inst) {}
        });

        return factory.mobiscrollInstance;
    };

    // onSet: function(event, inst) {},

    factory.updateTimeObj = function (selectedTimeObj = null) {
        factory.selectedTimeObj =
            selectedTimeObj instanceof Error
                ? factory.defaultSelectedTimeObj
                : selectedTimeObj;
    };

    factory.updateTime = function (start, end) {
        factory.updateTimeObj(factory.findSelectedTimeModelObj(start, end));

        if (!factory.oSearchTime.userSelected) {
            factory.oSearchTime["userSelected"] = angular.copy(
                factory.oSearchTime["default"]
            );
        }

        houseService.searchFilter.startTime =
            factory.oSearchTime.userSelected.from = start;
        houseService.searchFilter.endTime =
            factory.oSearchTime.userSelected.to = end;

        // console.log(houseService.searchFilter.startTime);

        if (factory.oSearchTime.userSelected.display === "") {
            factory.oSearchTime.userSelected.display =
                factory.selectedTimeObj.display;
        }
    };

    factory.findSelectedTimeModelObj = function (start, end) {
        let found = [];

        angular.forEach(factory.timeSelectorModel, function (obj) {
            if (obj.startTime == start && obj.endTime == end) {
                found.push(obj);
            }
        });

        return found.length > 0
            ? found[0] // deliver first result (to get "Hele dagen" not "fra 06")
            : new Error("no-time-obj", "Time obj blev ikke fundet");
    };

    factory.setHouseTimes = function (oSearchTime, wheelObj) {
        // searchBarFactory.updateTime(wheelObj.startTime, wheelObj.endTime);
        houseService.searchFilter.startTime = wheelObj.startTime;
        houseService.searchFilter.endTime = wheelObj.endTime;
        //$scope.searchFilter.hours = wheelObj.hours;

        if (!oSearchTime.userSelected) {
            oSearchTime["userSelected"] = {};
        }

        factory.oSearchTime.userSelected.display = wheelObj.display;
        factory.oSearchTime.userSelected.from = wheelObj.startTime;
        factory.oSearchTime.userSelected.hours =
            houseService.searchFilter.hours;

        factory.oSearchTime.userSelected.to = wheelObj.endTime;

        factory.oSearchTime.placeholderDisplay = "";

        oSearchTime.dirty = true;
    };

    // factory.updateUI = function (timeObj) {};

    factory.setTabIndexTimeOnOpen = function () {
        // avail param : oSearchActive
        //tabindex 5 - mobiscroller is set inside factory

        $("#hourSelector").attr("tabindex", "6");

        $("#search-btn-in-time-dropdown").attr("tabindex", "7");

        $("#search-btn-main a").attr("tabindex", "8");
    };

    factory.setTabIndexTimeOnClose = function () {
        // avail param : oSearchActive
        //reset mobiscroller is set inside mobiscrollFactory

        $("#hourSelector").attr("tabindex", "-1");

        $("#search-btn-in-time-dropdown").attr("tabindex", "-1");

        $("#search-btn-main a").attr("tabindex", "5");
    };

    factory.timeSelectorModel = [
        {
            display: "Morgen (06:00 - 09-00)",
            value: 1,
            startTime: 6,
            endTime: 9,
            displayInFilter: true,
            availablePeriods: [],
        },
        {
            display: "Formiddag (09:00 - 11-00)",
            value: 2,
            startTime: 9,
            endTime: 11,
            displayInFilter: true,
            availablePeriods: [],
        },
        {
            display: "Middag (11:00 - 13-00)",
            value: 3,
            startTime: 11,
            endTime: 13,
            displayInFilter: true,
            availablePeriods: [],
        },
        {
            display: "Eftermiddag (13:00 - 17-00)",
            value: 4,
            startTime: 13,
            endTime: 17,
            displayInFilter: true,
            availablePeriods: [],
        },
        {
            display: "Aften (17:00 - 23-00)",
            value: 5,
            startTime: 17,
            endTime: 23,
            displayInFilter: true,
            availablePeriods: [],
        },
        {
            display: "Hele dagen",
            value: 6,
            startTime: 0,
            endTime: -1,
            displayInFilter: true,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 06",
            value: 7,
            startTime: 6,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 07",
            value: 8,
            startTime: 7,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 08",
            value: 9,
            startTime: 8,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 09",
            value: 10,
            startTime: 9,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 10",
            value: 11,
            startTime: 10,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 11",
            value: 12,
            startTime: 11,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 12",
            value: 13,
            startTime: 12,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 13",
            value: 14,
            startTime: 13,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl :14",
            value: 15,
            startTime: 14,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 15",
            value: 16,
            startTime: 15,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 16",
            value: 17,
            startTime: 16,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 17",
            value: 18,
            startTime: 17,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 18",
            value: 19,
            startTime: 18,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 19",
            value: 20,
            startTime: 19,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 20",
            value: 21,
            startTime: 20,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 21",
            value: 22,
            startTime: 21,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
        {
            display: "Fra kl : 22",
            value: 23,
            startTime: 22,
            endTime: -1,
            displayInFilter: false,
            availablePeriods: [],
        },
    ];

    return factory;
}
